import React, { useRef, useState, useEffect } from "react";
import { Progress } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { useNavigate, useLocation } from "react-router-dom";
import backimage from "../../assets/icons/prev.svg";
import { toast } from "react-toastify";

const NewProject = () => {
  const [importedFiles, setImportedFiles] = useState([]);
  const [selectedFloorplan, setSelectedFloorplan] = useState({});
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.selectedImages) {
      setImportedFiles(location.state.selectedImages);
    }
  }, [location.state]);

  const handleAddFloor = () => {
    fileInputRef.current.click();
  };

  const handleChange = (e) => {
    const files = Array.from(e.target.files);
    setImportedFiles((prevImages) => [...prevImages, ...files]);
  };

  const removeFile = (indexToRemove) => {
    setImportedFiles((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleSliderSelected = () => {
    if (importedFiles.length > 0) {
      setSelectedFloorplan(importedFiles[selectedImageIndex]);
      navigate("/scanned-status", { state: { file: importedFiles[selectedImageIndex] } });
    } else {
      toast.error("No files imported. Cannot select floorplan.");
    }
  };

  return (
    <div className="new-project floor-plan-uploader">
      <div className="back-button-container">
        <img
          src={backimage}
          className="back-image-styles"
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
      </div>
      <div className="top">
        <h2>New Project</h2>
        <div className="content d-none">
          <div className="left" onClick={handleSliderSelected}>
            <img src="/assets/images/scanner.png" alt="" />
          </div>
          <hr className="vertical-hr" />
          <div className="middle">
            {importedFiles.map((file, index) => (
              <div className="d-flex align-items-start" key={index}>
                <div className="floor d-flex">
                  <img src="/assets/icons/file.svg" alt="" />
                  <div className="bar">
                    <div className="bar-content">
                      <p className="bar-content-fileName">{file.name}</p>
                      <img
                        onClick={() => removeFile(index)}
                        src="/assets/icons/cancel.svg"
                        alt=""
                        className="pointer"
                      />
                    </div>
                    <Progress
                      percent={100}
                      trailColor={"white"}
                      showInfo={false}
                    />
                    <div className="bar-content">
                      <p>100% done</p>
                      <p>{file.speed}</p>
                    </div>
                  </div>
                </div>
                <div className="right-content">
                  <h3>Status</h3>
                  <div className="status-btns">
                    <button className="pending">Pending</button>
                  </div>
                </div>
              </div>
            ))}
            <button onClick={handleAddFloor}>Add Floor</button>
          </div>
        </div>

        <div className="file-uploader">
          <div className="left" onClick={handleSliderSelected}>
            <img src="/assets/images/scanner.png" alt="" />
          </div>
          <div className="right">
            <div className="header">
              <h3>Imported Files</h3>
              <h3>Status</h3>
            </div>
            {importedFiles.map((file, index) => (
              <div className="file-status-wrapper" key={index}>
                <div className="add-file">
                  <div className="progress-bar">
                    <div className="bar">
                      <img src="/assets/icons/file.svg" alt="" />
                      <div className="bar-content w-100">
                        <div className="d-flex w-100 justify-content-between">
                          <p className="file-name">
                            {file.name.substring(0, 25)}
                            {file.name.length > 25 && " ..."}
                          </p>
                          <img
                            onClick={() => removeFile(index)}
                            src="/assets/icons/cancel.svg"
                            alt=""
                            className="pointer cancel-img"
                          />
                        </div>
                        <Progress
                          percent={100}
                          trailColor={"white"}
                          showInfo={false}
                        />
                        <div className="d-flex w-100 justify-content-between">
                          <p>100% done</p>
                          <p>{file.speed}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="scan-status">
                  <p className="status-chips pending">Pending</p>
                </div>
              </div>
            ))}
            <div>
              <button className="btn-primary mt-5" onClick={handleAddFloor}>
                Add Floor
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom">
        {importedFiles &&
          importedFiles?.map((file, index) => (
            <h3 key={index}>
              {index === selectedImageIndex && file.name ? file.name : ""}
            </h3>
          ))}
        <div className="floor-slider">
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            pagination={{ clickable: true }}
            navigation={true}
            modules={[Pagination, Navigation]}
            className="mySwiper"
            onSlideChange={(swiper) => setSelectedImageIndex(swiper.activeIndex)}
          >
            {importedFiles.map((file, index) => (
              <SwiperSlide key={index}>
                <img
                  src={URL.createObjectURL(file)}
                  alt={file.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <button onClick={handleSliderSelected}>
          Edit Floor <img src="/assets/icons/edit.svg" alt="" />
        </button>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        style={{ display: "none" }}
        onChange={handleChange}
      />
    </div>
  );
};

export default NewProject;
